module.exports = __webpack_public_path__ + "static/media/ShinyFloorIcon.4cd71a9d.svg";